let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("akl5K")).then(() => parcelRequire('aDQEH'));